var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive && _vm.show)?_c('div',{staticClass:"tab contentWrapper"},[_vm._t("default",null,null,{ id: _vm.id, name: _vm.name, active: _vm.isActive })],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }